import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Bot, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

function fmtBRL(v) {
  return Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export default function AssistantUsageCard() {
  const { apiCall } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await apiCall("get", "/assistant/usage");
      setData(res.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <Card className="p-4" data-testid="assistant-usage-card">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Bot className="h-4 w-4 text-muted-foreground" strokeWidth={1.5} />
          <h3 className="text-xs uppercase tracking-widest font-medium">Custo da IA (Universal Key)</h3>
        </div>
        <Button size="icon" variant="ghost" onClick={load} className="h-7 w-7">
          <RefreshCw className={`h-3 w-3 ${loading ? "animate-spin" : ""}`} strokeWidth={1.5} />
        </Button>
      </div>
      <p className="text-[10px] text-muted-foreground mb-3">
        Estimativa baseada nos tokens usados pelo assistente (Claude). Gregory AI = R$ 0.
      </p>
      {data ? (
        <div className="grid grid-cols-2 gap-2 text-sm">
          <div className="p-2 rounded-md bg-secondary/40">
            <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Hoje</div>
            <div className="font-medium" data-testid="usage-today">{fmtBRL(data.today.brl)}</div>
            <div className="text-[10px] text-muted-foreground">{data.today.calls} consultas</div>
          </div>
          <div className="p-2 rounded-md bg-secondary/40">
            <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Semana</div>
            <div className="font-medium" data-testid="usage-week">{fmtBRL(data.week.brl)}</div>
            <div className="text-[10px] text-muted-foreground">{data.week.calls} consultas</div>
          </div>
          <div className="p-2 rounded-md bg-secondary/40">
            <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Mês</div>
            <div className="font-medium" data-testid="usage-month">{fmtBRL(data.month.brl)}</div>
            <div className="text-[10px] text-muted-foreground">{data.month.calls} consultas</div>
          </div>
          <div className="p-2 rounded-md bg-secondary/40">
            <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Total</div>
            <div className="font-medium" data-testid="usage-total">{fmtBRL(data.all_time.brl)}</div>
            <div className="text-[10px] text-muted-foreground">{data.all_time.calls} consultas</div>
          </div>
        </div>
      ) : (
        <div className="text-xs text-muted-foreground text-center py-3">Carregando…</div>
      )}
    </Card>
  );
}
